import {View} from './view';
import {Translations} from '../config/translations';

export class TaxView extends View {

    render(addressConfig: any) {
        const taxForm = document.createElement('div');
        taxForm.setAttribute('id', 'tax-form-block');

        taxForm.innerHTML =
            `<form class='hs-form stacked df-f df-f-tax' id='df-tax-form' action=''>
                ${this.getTaxElements(addressConfig.countries)}
            </form>`;

        const taxFormFragment = document.createDocumentFragment();
        taxFormFragment.appendChild(taxForm);

        const container = this.getDFContainer();
        container.appendChild(taxFormFragment);
    }

    getTaxElements = (countries: any[]) => {
        return `<fieldset class='form-columns-1 df-fieldset'>
                    <div class='field hs-form-field df-field'>
                        <label>
                            <span class='df-f-label'>${Translations.TAX_BILLING_COUNTRY}</span><span class='hs-form-required'>*</span>
                        </label>
                        <div>
                            <select id='tax-billing-countries' class='input hs-input df-select' name='tax-billing-countries'>
                                ${this.populateCountryOptions(countries)}
                            </select>
                        </div>
                    </div>
                </fieldset>
                <fieldset id='tax-billing-states-container' class='form-columns-1 df-fieldset'>
                    <div class='field hs-form-field df-field'>
                        <label>
                            <span class='df-f-label'>${Translations.TAX_BILLING_STATE}</span><span class='hs-form-required'>*</span>
                        </label>
                        <div>
                            <select id='tax-billing-states' class='input hs-input df-select' name='tax-billing-states'>
                            </select>
                        </div>
                    </div>
                </fieldset>
                <fieldset id='tax-billing-zip-container' class='form-columns-1 df-fieldset'>
                    <div class='field hs-form-field df-field'>
                        <label>
                            <span class='df-f-label'>${Translations.TAX_BILLING_ZIP}</span><span class='hs-form-required'>*</span>
                        </label>
                        <div class='input'>
                            <input id='tax-billing-zip' type='text' class='hs-input df-input' name='tax-billing-zip' />
                        </div>
                    </div>
                </fieldset>
                <fieldset class='form-columns-1 df-fieldset'>
                    <label class='error' id='tax-billing-zip-error'>${Translations.TAX_BILLING_ZIP_REQUIRED}</label>
                </fieldset>`;
    }

    populateCountryOptions = (countries: any[]) => {
        let options = '';
        for (const country of countries) {
            options += `<option value="${country.code}" name="${country.name}" code="${country.code}">${country.name}</option>`;
        }
        return options;
    }

    clearStateOptions = () => {
        const taxBillingStatesElement = this.getStatesElement();
        if (taxBillingStatesElement) {
            taxBillingStatesElement.innerHTML = '';
        }
    }

    populateStateOptions = (states: any = []) => {
        if (states.length === 0) {
            return;
        }
        const taxBillingStatesElement = this.getStatesElement();
        if (taxBillingStatesElement) {
            let options = '';
            for (const state of states) {
                options += `<option value="${state.code}" name="${state.name}" code="${state.code}">${state.name}</option>`;
            }
            taxBillingStatesElement.innerHTML = options;
        }
    }

    getCountriesElement = () => {
        return this.getHtmlElement('#tax-billing-countries');
    }

    getStatesElement = () => {
        return this.getHtmlElement('#tax-billing-states');
    }

    getZipElement = () => {
        return this.getHtmlElement('#tax-billing-zip');
    }

    showZipError = () => {
        const zipErrorElement = this.getHtmlElement('#tax-billing-zip-error');
        this.show(zipErrorElement);
    }

    hideZipError = () => {
        const zipErrorElement = this.getHtmlElement('#tax-billing-zip-error');
        this.hide(zipErrorElement);
    }

}
